import React from 'react';

const socialLinks = [
    {
        label: 'LinkedIn',
        href: 'https://www.linkedin.com/in/alessio-pannozzo-7a9101176/',
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
                <path d="M6.94 6.5A1.94 1.94 0 1 1 3.06 6.5a1.94 1.94 0 0 1 3.88 0ZM3.5 8.75h3V20h-3V8.75Zm5.75 0h2.87v1.55h.04c.4-.75 1.38-1.55 2.83-1.55 3.03 0 3.59 1.99 3.59 4.58V20h-3v-5.4c0-1.29-.02-2.95-1.8-2.95-1.8 0-2.07 1.41-2.07 2.86V20h-3V8.75Z" />
            </svg>
        ),
    },
    {
        label: 'GitHub',
        href: 'https://github.com/AP71',
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
                <path d="M12 2a10 10 0 0 0-3.16 19.49c.5.09.68-.21.68-.48v-1.7c-2.77.6-3.36-1.18-3.36-1.18-.46-1.17-1.12-1.48-1.12-1.48-.92-.63.07-.62.07-.62 1.02.08 1.56 1.05 1.56 1.05.91 1.56 2.39 1.11 2.97.85.09-.66.35-1.11.64-1.36-2.21-.25-4.53-1.1-4.53-4.9 0-1.08.39-1.97 1.03-2.66-.1-.25-.45-1.26.1-2.62 0 0 .84-.27 2.75 1.02a9.6 9.6 0 0 1 5 0c1.91-1.29 2.75-1.02 2.75-1.02.55 1.36.2 2.37.1 2.62.64.69 1.03 1.58 1.03 2.66 0 3.81-2.33 4.64-4.55 4.89.36.31.68.93.68 1.87v2.78c0 .27.18.58.69.48A10 10 0 0 0 12 2Z" />
            </svg>
        ),
    },
];

const Contact = () => {
    return (
        <section className="w-full max-h-1/2 flex flex-col dark:bg-earth-900 px-4 sm:px-6 lg:px-8 py-8 overflow-hidden">
            <div className="w-full max-w-2xl mx-auto text-center flex-1 flex flex-col items-center justify-center">
                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-earth-900 dark:text-earth-50 leading-tight">
                    Contact Me
                </h2>

                <p className="mx-auto mt-4 max-w-xl text-base sm:text-lg text-earth-800 dark:text-earth-100 leading-7">
                    Have a project in mind or want to collaborate? Get in touch.
                </p>

                <a
                    href="mailto:alessiopannozzo.71@gmail.com"
                    className="mt-8 inline-flex items-center gap-3 text-base sm:text-lg font-medium text-earth-800 dark:text-earth-100 hover:text-earth-900 dark:hover:text-earth-50 transition-colors duration-200"
                >
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-earth-700 text-earth-800 dark:border-earth-100/30 dark:text-earth-50">
                        <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
                            <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 3-8 5L4 7V6l8 5 8-5v1Z" />
                        </svg>
                    </span>
                    <span>alessiopannozzo.71@gmail.com</span>
                </a>

                <div className="mt-10 flex items-center justify-center gap-3">
                    {socialLinks.map((item) => (
                        <a
                            key={item.label}
                            href={item.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={item.label}
                            className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-earth-700 text-earth-800 transition-transform duration-200 hover:-translate-y-0.5 hover:border-earth-800 dark:border-earth-100/30 dark:text-earth-50 dark:hover:border-earth-100/60"
                        >
                            {item.icon}
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Contact;
